import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import classNames from 'classnames';
import SectionWrapper from 'ferries/Home/components/SectionWrapper';
import {Card, CardBody} from 'components/card';
import BenefitColumn from 'ferries/Home/components/Benefits/BenefitColumn';
import BenefitColumnReview from 'ferries/Home/components/Benefits/BenefitColumnReview';
import LazyImage from 'helpers/LazyImage';
import {replaceAssetsImgUrl} from 'cms/helpers/common';
import {MOBILE_WIDTH, TABLET_WIDTH} from 'helpers/stableValues';

const sliderSettings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 3,
  arrows: true,
  responsive: [{
    breakpoint: TABLET_WIDTH,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2
    }
  }, {
    breakpoint: MOBILE_WIDTH,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }]
};

const Benefits = ({benefitsAndUpsells}) => {
  const {title, subtitle, description, benefits, upsells, trs} = benefitsAndUpsells;
  const [benefitNil, benefitFirst, benefitSec, benefitThird] = benefits;
  const trustpilotRating = parseFloat(benefitFirst.benefit_column_stars);
  const googleRating = parseFloat(benefitSec.benefit_column_stars);
  const upsellsLength = upsells.length - 1;
  const {bookNow} = trs;

  return (
    <SectionWrapper title={title} subtitle={subtitle} description={description}>
      <Card shadow className="mb-6">
        <CardBody className="p-0">
          <div className="grid no-gutter">
            <BenefitColumn
              bgImage={benefitNil.benefit_column_image.url}
              url={benefitNil.benefit_column_url}
              header={benefitNil.benefit_column_header}
              text={benefitNil.benefit_column_text}
            />
            <div
              className="grid-item-sm text-white d-flex flex-column p-4"
              style={{backgroundColor: `${benefitFirst.benefit_column_color}`}}
            >
              <div className="text-white font-bold mb-4" style={{fontSize: '21px', fontWeight: '500'}}
                dangerouslySetInnerHTML=
                  {{
                    __html: `${benefitFirst.benefit_column_header} ${benefitSec.benefit_column_header}`
                  }}>
              </div>
              <BenefitColumnReview
                url={benefitFirst.benefit_column_url}
                stars={benefitFirst.benefit_column_stars}
                rating={trustpilotRating}
                text={benefitFirst.benefit_column_text}
              />
              <div className="wave-line"></div>
              <BenefitColumnReview
                isGoogle
                url={benefitSec.benefit_column_url}
                stars={benefitSec.benefit_column_stars}
                rating={googleRating}
                text={benefitSec.benefit_column_text}
              />
            </div>
            <BenefitColumn
              bgImage={benefitThird.benefit_column_image.url}
              url={benefitThird.benefit_column_url}
              header={benefitThird.benefit_column_header}
              text={benefitThird.benefit_column_text}
            />
          </div>
        </CardBody>
      </Card>
      <Slider {...sliderSettings}>
        {
          upsells.map(({upsell_icon, upsell_name, upsell_text, upsell_url}, index) => {
            const upsellClass = classNames('text-center', {
              'px-3': index !== 0 && index !== upsellsLength,
              'pl-3': index === upsellsLength,
              'pr-3': index === 0
            });

            return (
              <div key={upsell_name} className={upsellClass}>
                <Card shadow>
                  <CardBody className="p-4">
                    <LazyImage
                      wrapperClass="mx-auto d-flex justify-content-center"
                      src={replaceAssetsImgUrl(upsell_icon?.url)}
                      width="30"
                      height="30"
                      title={upsell_name}
                      alt={upsell_name}
                    />
                    <div className="h3 mt-5 text-primary">{upsell_name}</div>
                    <div className="my-4 max-lines-3">{upsell_text}</div>
                    <a href={upsell_url} target="_blank" rel="noreferrer">
                      {bookNow}
                      <i className="icon icon-right-arrow ml-2 icon-sm" />
                    </a>
                  </CardBody>
                </Card>
              </div>
            );
          })
        }
      </Slider>
    </SectionWrapper>
  );
};

Benefits.propTypes = {
  benefitsAndUpsells: PropTypes.shape({
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    description: PropTypes.string,
    benefits: PropTypes.array.isRequired,
    upsells: PropTypes.array.isRequired,
    trs: PropTypes.shape({
      bookNow: PropTypes.string.isRequired
    })
  })
};

export default Benefits;
